module.exports = __webpack_public_path__ + "img/logo-zc-edasinvoize.0e0c0c5a.webp";